import React from 'react';
import {
  Router as DefaultRouter,
  Route,
  Switch,
  StaticRouter,
} from 'react-router-dom';
import dynamic from 'umi/dynamic';
import renderRoutes from 'umi/lib/renderRoutes';
import history from '@@/history';
import RendererWrapper0 from '/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/pages/.umi-production/LocaleWrapper.jsx';
import _dvaDynamic from 'dva/dynamic';

const Router = require('dva/router').routerRedux.ConnectedRouter;

const routes = [
  {
    path: '/sso/callback',
    icon: 'search',
    name: 'sso',
    hideInMenu: true,
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () => import('../SSO/index'),
          LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
            .default,
        })
      : require('../SSO/index').default,
    exact: true,
  },
  {
    path: '/proof',
    name: 'Proof',
    hideInMenu: true,
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () => import('../Proof/index'),
          LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
            .default,
        })
      : require('../Proof/index').default,
    exact: true,
  },
  {
    path: '/feedbackInfo',
    name: 'FeedbackInfo',
    hideInMenu: true,
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () => import('../FeedbackInfo/index'),
          LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
            .default,
        })
      : require('../FeedbackInfo/index').default,
    exact: true,
  },
  {
    path: '/oldShopFeedback',
    name: 'OldShopFeedback',
    hideInMenu: true,
    Routes: [require('../Authorized').default],
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () => import('../OldShopFeedback/layout'),
          LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
            .default,
        })
      : require('../OldShopFeedback/layout').default,
    routes: [
      {
        path: '/oldShopFeedback',
        name: 'index',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () => import('../OldShopFeedback/index'),
              LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                .default,
            })
          : require('../OldShopFeedback/index').default,
        exact: true,
      },
    ],
  },
  {
    path: '/apolloVisit',
    icon: 'search',
    name: 'apolloVisit',
    hideInMenu: true,
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () => import('../ApolloVisit/index'),
          LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
            .default,
        })
      : require('../ApolloVisit/index').default,
    exact: true,
  },
  {
    path: '/message/repeat-entertainment',
    name: 'repeat-entertainment',
    hideInMenu: true,
    Routes: [require('../Authorized').default],
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () => import('../Message/repeatEntertainment'),
          LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
            .default,
        })
      : require('../Message/repeatEntertainment').default,
    exact: true,
  },
  {
    path: '/',
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () => import('../../layouts/BasicLayout'),
          LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
            .default,
        })
      : require('../../layouts/BasicLayout').default,
    checkUac: true,
    Routes: [
      require('../Authorized').default,
      require('../UacAuthorized').default,
      require('../../components/MobileNotify/index').default,
    ],
    routes: [
      {
        path: '/',
        icon: 'search',
        name: 'poi',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () => import('../Search/Poi'),
              LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                .default,
            })
          : require('../Search/Poi').default,
        exact: true,
      },
      {
        path: '/new',
        icon: 'plus',
        name: 'new',
        routes: [
          {
            path: '/new/new-shop',
            name: 'newshop',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../New/NewShop'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../New/NewShop').default,
            exact: true,
          },
          {
            path: '/new/new-batch-shop',
            name: 'new-batch-shop',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../New/NewBatchShopList'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../New/NewBatchShopList').default,
            exact: true,
          },
          {
            path: '/new/new-virtualpoi',
            name: 'virtual-poi',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../New/NewVirtualpoi'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../New/NewVirtualpoi').default,
            exact: true,
          },
        ],
      },
      {
        path: '/errors',
        icon: 'tool',
        name: 'errors',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () => import('../Search/Poi'),
              LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                .default,
            })
          : require('../Search/Poi').default,
        routes: [
          {
            path: '/errors/base-info',
            name: 'base-info',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Errors/BaseInfo/index'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../Errors/BaseInfo/index').default,
            exact: true,
          },
          {
            path: '/errors/special-business-time',
            name: 'special-business-time',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Errors/BaseInfo/SpecialBusinessTime'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../Errors/BaseInfo/SpecialBusinessTime').default,
            exact: true,
          },
          {
            path: '/errors/batch-brand-shop-list',
            name: 'BatchBrandShopList',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Errors/BatchBrandShopList/index'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../Errors/BatchBrandShopList/index').default,
            exact: true,
          },
          {
            path: '/errors/shop-status',
            name: 'shopStatus',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Errors/ShopStatus'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../Errors/ShopStatus').default,
            exact: true,
          },
          {
            path: '/errors/repeat',
            name: 'repeat',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Errors/Repeat/Repeat'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../Errors/Repeat/Repeat').default,
            routes: [
              {
                path: '/errors/repeat/merge',
                name: 'merge',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () => import('../Errors/Repeat/Merge'),
                      LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Errors/Repeat/Merge').default,
                exact: true,
              },
              {
                path: '/errors/repeat/split',
                name: 'split',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () => import('../Errors/Repeat/Split'),
                      LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Errors/Repeat/Split').default,
                exact: true,
              },
              {
                path: '/errors/repeat/batch-split-shop',
                name: 'BatchSplitShop',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import('../Errors/Repeat/BatchSplitShop'),
                      LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Errors/Repeat/BatchSplitShop').default,
                exact: true,
              },
            ],
          },
          {
            path: '/errors/shop-relations',
            name: 'shopRelations',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Errors/ShopRelations/index'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../Errors/ShopRelations/index').default,
            exact: true,
          },
          {
            path: '/errors/fake-info',
            name: 'fake-info',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Errors/FakeInfo'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../Errors/FakeInfo').default,
            exact: true,
          },
          {
            path: '/errors/multi-fake-info',
            name: 'multi-fake-info',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Errors/MultiFake/MultiFakeInfo'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../Errors/MultiFake/MultiFakeInfo').default,
            exact: true,
          },
          {
            path: '/errors/multi-fake-info-download',
            name: 'multi-fake-info-download',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Errors/MultiFake/MultiFakeInfoDownload'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../Errors/MultiFake/MultiFakeInfoDownload').default,
            exact: true,
          },
          {
            path: '/errors/groups',
            name: 'groups',
            routes: [
              {
                path: '/errors/groups/new-group',
                name: 'new-group',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () => import('../Errors/Groups/NewGroup'),
                      LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Errors/Groups/NewGroup').default,
                exact: true,
              },
              {
                path: '/errors/groups/remove-group',
                name: 'remove-group',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () => import('../Errors/Groups/RemoveGroup'),
                      LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Errors/Groups/RemoveGroup').default,
                exact: true,
              },
              {
                path: '/errors/groups/add-groups',
                name: 'add-groups',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () => import('../Errors/Groups/AddGroups'),
                      LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Errors/Groups/AddGroups').default,
                exact: true,
              },
            ],
          },
          {
            path: '/errors/parent',
            name: 'parent',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Errors/Parent'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../Errors/Parent').default,
            exact: true,
          },
          {
            path: '/errors/guide',
            name: 'guide',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Errors/Guide'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../Errors/Guide').default,
            exact: true,
          },
          {
            path: '/errors/wedding',
            name: 'wedding',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Errors/Wedding'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../Errors/Wedding').default,
            exact: true,
          },
          {
            path: '/errors/shop-tag',
            name: 'shop-tag',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Errors/ShopTag'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../Errors/ShopTag').default,
            exact: true,
          },
          {
            path: '/errors/result/success',
            name: 'success',
            hideInMenu: true,
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Result/Success'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../Result/Success').default,
            exact: true,
          },
          {
            path: '/errors/result/succeed',
            name: 'succeed',
            hideInMenu: true,
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Result/SuccessWithoutFlowId'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../Result/SuccessWithoutFlowId').default,
            exact: true,
          },
          {
            path: '/errors/result/parent-result',
            name: 'parent-result',
            hideInMenu: true,
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Result/ParenthoodResult.js'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../Result/ParenthoodResult.js').default,
            exact: true,
          },
          {
            path: '/errors/groupon/service',
            name: 'groupon-service',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Errors/Groupon/NewService'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../Errors/Groupon/NewService').default,
            exact: true,
          },
          {
            path: '/errors/multi-parent',
            name: 'multi-parent',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Errors/MultiParent/MultiParent.js'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../Errors/MultiParent/MultiParent.js').default,
            exact: true,
          },
        ],
      },
      {
        path: '/iframe/:encodedURL',
        icon: 'tool',
        name: 'region',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () => import('../IFrameContainer'),
              LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                .default,
            })
          : require('../IFrameContainer').default,
        routes: [
          {
            path:
              '/iframe/https%3A%2F%2Fpdc.sankuai.com%2Fgis%2Fregion%2Foperate%2Fadd%3Fshellcontrol%3Dforcehide',
            name: 'region-add',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../IFrameContainer'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../IFrameContainer').default,
            exact: true,
          },
          {
            path:
              '/iframe/https%3A%2F%2Fpdc.sankuai.com%2Fgis%2Fregion%2Foperate%2Fupdate%3Fshellcontrol%3Dforcehide',
            name: 'region-update',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../IFrameContainer'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../IFrameContainer').default,
            exact: true,
          },
          {
            path:
              '/iframe/https%3A%2F%2Fpdc.sankuai.com%2Fgis%2Fregion%2Fevaluate%2Frecord%3Fshellcontrol%3Dforcehide',
            name: 'region-record',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../IFrameContainer'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../IFrameContainer').default,
            exact: true,
          },
        ],
      },
      {
        path: '/info',
        icon: 'info-circle',
        name: 'info',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () => import('../Info/SelectTypeHeader'),
              LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                .default,
            })
          : require('../Info/SelectTypeHeader').default,
        routes: [
          {
            path: '/info/my-report',
            icon: 'issues-close',
            name: 'my-report',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Info/MyReport'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../Info/MyReport').default,
            exact: true,
          },
          {
            path: '/info/my-todo',
            icon: 'warning',
            name: 'my-todo',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Info/MyTodo'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../Info/MyTodo').default,
            exact: true,
          },
          {
            path: '/info/my-newshops',
            icon: 'plus-square',
            name: 'my-newshops',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Info/MyNewShops'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../Info/MyNewShops').default,
            exact: true,
          },
        ],
      },
      {
        path: '/qualification',
        icon: 'snippets',
        name: 'qualification',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () => import('../Qualification/index'),
              LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                .default,
            })
          : require('../Qualification/index').default,
        exact: true,
      },
      {
        path: '/shoplog',
        icon: 'database',
        name: 'shoplog',
        routes: [
          {
            path: '/shoplog/index',
            icon: 'database',
            name: 'index',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../ShopLog'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../ShopLog').default,
            exact: true,
          },
          {
            path: '/shoplog/download',
            icon: 'download',
            name: 'download',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../ShopLog/Download'),
                  LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                    .default,
                })
              : require('../ShopLog/Download').default,
            exact: true,
          },
        ],
      },
      {
        path: '/operation',
        icon: 'file-unknown',
        name: 'operation',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () => import('../Search/Operation'),
              LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                .default,
            })
          : require('../Search/Operation').default,
        exact: true,
      },
      {
        path: '/my-abnormalshops',
        name: 'my-abnormalshops',
        hideInMenu: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () => import('../Search/MyAbnormalShops'),
              LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                .default,
            })
          : require('../Search/MyAbnormalShops').default,
        exact: true,
      },
      {
        path: '/result/success',
        name: 'success',
        hideInMenu: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () => import('../Result/BasicSuccess'),
              LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                .default,
            })
          : require('../Result/BasicSuccess').default,
        exact: true,
      },
      {
        path: '/universalPage/:encodedURL',
        name: 'universalPage',
        hideInMenu: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () => import('../UniversalPage/index'),
              LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                .default,
            })
          : require('../UniversalPage/index').default,
        exact: true,
      },
      {
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () => import('../404'),
              LoadingComponent: require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/components/PageLoading/index')
                .default,
            })
          : require('../404').default,
        exact: true,
      },
    ],
  },
];
window.g_routes = routes;
const plugins = require('umi/_runtimePlugin');
plugins.applyForEach('patchRoutes', { initialValue: routes });

export { routes };

export default class RouterWrapper extends React.Component {
  unListen() {}

  constructor(props) {
    super(props);

    // route change handler
    function routeChangeHandler(location, action) {
      plugins.applyForEach('onRouteChange', {
        initialValue: {
          routes,
          location,
          action,
        },
      });
    }
    this.unListen = history.listen(routeChangeHandler);
    // dva 中 history.listen 会初始执行一次
    // 这里排除掉 dva 的场景，可以避免 onRouteChange 在启用 dva 后的初始加载时被多执行一次
    const isDva =
      history.listen
        .toString()
        .indexOf('callback(history.location, history.action)') > -1;
    if (!isDva) {
      routeChangeHandler(history.location);
    }
  }

  componentWillUnmount() {
    this.unListen();
  }

  render() {
    const props = this.props || {};
    return (
      <RendererWrapper0>
        <Router history={history}>{renderRoutes(routes, props)}</Router>
      </RendererWrapper0>
    );
  }
}
